export const LOAD_REASONS = 'LOAD_REASONS'
export const ADD_REASON = 'ADD_REASON'
export const UPDATE_REASON = 'UPDATE_REASON'
export const DELETE_REASON = 'DELETE_REASON'
export const LOAD_ALL_REASONS = 'LOAD_ALL_REASONS'
